/**
 * Caroussel 
 */
// @ts-ignore
const carousselSwiper = new Swiper('.swiper__slide_container', {
    // Optional parameters
    loop: true,
    spaceBetween: 10,
    speed: 1000,
    allowTouchMove: false,

    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },

});


/**
 * Video : iframe image / autoplay on click
 */
let play = document.querySelector('.iframe_image');
let iframe = <HTMLVideoElement>document.querySelector('.video_container iframe');

if (play) {
    play.addEventListener('click', function (e) {
        this.style.display = 'none';
        iframe.src += '&autoplay=1';
        console.log("clicked on :", this);
    })
}